// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G7SO","largestCol":"styles_largestCol__GPUWm","smallestCol":"styles_smallestCol__1igfY"};